/*
 * @Author: leoqyli
 * @Date: 2021-11-09 11:27:09
 * @LastEditTime: 2021-11-10 17:11:31
 * @LastEditors: Please set LastEditors
 * @Description: 用于已有选中时的回显示处理，此处较复杂的逻辑是为了填之前 回显没有人员类型导致拉取的数据不正确的问题
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/js/utils/getDetail/getDetailByReload.js
 */
import getPeopleDetailByUin from './getPeopleDetailByUin';
import getTroopDetailById from './getTroopDetailByIdForRecent';
import getGQQPeopleDetailByUin from './getGQQPeopleDetailByUin';
import getGtroopDetailById from './getGtroopDetailById';
import getColleagueDetail from './getColleagueDetail';

function getDiscussFaceById(params) {
    const list = params.ids;
    return new Promise((resolve) => {
        const result = [];
        list.forEach((item) => {
            result.push({
                id: item,
                face: '',
            });
        });
        resolve(result);
    });
}

function noHasListComputed(peopleIds, resPeopleHash) {
    const noHasList = [];
    peopleIds.forEach((x) => {
        if (!(x in resPeopleHash)) {
            noHasList.push(x);
        }
    });
    return noHasList;
}

export default function (params) {
    const { tabs, list } = params;
    const tabsReg = RegExp(`^(${tabs.join('|')})$`);
    // const tabsReg = RegExp(tabs.join('|'));

    const peopleIds = [];
    const troopIds = [];
    const discussIds = [];
    const result = {
        people: {},
        troop: {},
        discuss: {},
    };

    list.forEach((item) => {
        switch (item.metaSourceType || item.sourceType) {
        case 'people':
            peopleIds.push(item.id);
            break;
        case 'troop':
            troopIds.push(item.id);
            break;
        case 'discuss':
            discussIds.push(item.id);
            break;
        default:
            peopleIds.push(item.id);
        }
    });

    const discussPromise = getDiscussFaceById({
        ids: discussIds,
    });

    let peoplePromise;

    let troopPromise;

    // 当存在 个Q版的 GQQFriend Gtroop 时，认为当前为个Q版，从业务上讲，不存在个Q版和企点QQ好友同时存在的情况
    if (tabsReg.test('GQQFriend') || tabsReg.test('Gtroop')) {
        // if (tabsReg.test('GQQFriend') || tabsReg.test('Gtroop')) {
        peoplePromise = getGQQPeopleDetailByUin({
            ids: peopleIds,
        });

        troopPromise = getGtroopDetailById({
            ids: troopIds,
        });
    } else if (tabsReg.test('colleague')) {
        peoplePromise = getColleagueDetail(peopleIds);
    }

    if (!peoplePromise) {
        peoplePromise = getPeopleDetailByUin({
            ids: peopleIds,
        });
    }

    if (!troopPromise) {
        troopPromise = getTroopDetailById({
            ids: troopIds,
        });
    }

    // 当存在同事这个类型的时候， people 应该先从这里获取，倘若获取不到再从qq好友里获取

    return new Promise((resolve) => {
        Promise.all([discussPromise, peoplePromise, troopPromise]).then((res) => {
            res[0].forEach((item) => {
                result.discuss[item.id] = {
                    name: item.name,
                    face:
                        'https://bqq.gtimg.com/qidian-stellaris-mobile/public-assets/contact-selector/discuss_default_avatar.png',
                };
            });

            res[2].forEach((item) => {
                result.troop[item.uin] = {
                    name: item.name,
                    face: item.face,
                };
            });

            // eslint-disable-next-line prefer-destructuring
            if (Object.keys(res[1]).length < peopleIds.length && tabsReg.test('colleague')) {
                let peopleHash = res[1];
                // 如果返回的 people 的 数目 跟请求的数据不一致，并且当前有同事这个 tab 存在， 则有可能是请求同事数据时有部分非同事的数据并没有返回结果，此时需要再次调用 qq 好友的接口重新获取剩余数据
                const noHasList = noHasListComputed(peopleIds, res[1]);
                getPeopleDetailByUin({
                    ids: noHasList,
                }).then((l) => {
                    peopleHash = { ...peopleHash, ...l };
                    result.people = peopleHash;
                    console.log('获取到的回显数据:', result);
                    resolve(result);
                });
            } else {
                // eslint-disable-next-line prefer-destructuring
                result.people = res[1];
                console.log('获取到的回显数据:', result);
                resolve(result);
            }
        });
    });
}
